import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-225dfabf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, " 404 ", -1))

import { useI18n } from 'vue-i18n';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_b_button, {
        variant: "primary",
        to: { name: 'home' }
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('Back to homepage')), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})